import BackToHomeLink from "../components/BackToHomeLink";

function About() {
  return (
    <div>
      <BackToHomeLink />
      <div className="about">
        <img
          src="/IMG_0450.PNG"
          className="about-image"
          alt="Harry Kaden's headshot"
        />
        <div className="about-paragraph">
          <h2>About Me</h2>
          <p>
            My name is Harry Kaden and I am a New York City based software
            engineer and music producer.
          </p>

          <p>
            After graduating from Georgetown in 2024, I have been in New York
            since late 2024 as a full stack Software Engineer 1. I specialize in
            relational databases, UX/UI design, and restful API implementation.
          </p>
          <p>
            In my free time I work with independent artists writing, producing,
            recording, mixing, and mastering original music.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
